import { render, staticRenderFns } from "./center_detail.vue?vue&type=template&id=7bd132ca"
import script from "./center_detail.vue?vue&type=script&lang=js"
export * from "./center_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports